import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import WhitelabelContext from 'shared/setup/WhitelabelContext.jsx';
import SavedSearch from '../savedSearch/SavedSearch.jsx';
import NumberOfResults from './NumberOfResults.jsx';
import SeoBreadcrumbs from '../seo/SeoBreadcrumbs.jsx';

export class TopBar extends React.PureComponent {
    render() {
        return this.props.isMobile ? (
            <div className="topbar-level2 u-position-fixed u-ma0">
                <div className="nav-level2">
                    <div className="grid" style={{ height: '50px' }}>
                        <div className="grid__unit u-size1of3">
                            {this.context.disableSavedSearch ? <span>&nbsp;</span> : <SavedSearch isLoggedIn={this.props.isLoggedIn} />}
                        </div>
                        <div className="grid__unit u-size1of3 u-text-center">
                            <span className="u-t3 u-display-inline-block u-ma16">
                                <NumberOfResults id={'numberOfResultsTop'} />
                            </span>
                        </div>
                        <div className="grid__unit u-size1of3 u-text-right">
                            <button
                                className="button button--default button--small u-ma16 u-ml0 u-float-right"
                                id="showFilter"
                                data-testid="showFilter"
                                onClick={this.props.showFilters}>
                                {this.props.t('action.showFilter')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <section className="panel grid">
                <ul className="breadcrumbs grid__unit u-size3of4">
                    <li>
                        <a href={this.props.t('breadcrumb.travel')}>{this.props.t('travel')}</a>
                    </li>
                    <li>
                        <span className="u-display-inline-block u-ma0 u-b1">
                            <a href={this.props.t('breadcrumb.flight')} data-testid="submarket">
                                {this.props.t('flight.title')}
                            </a>
                        </span>
                    </li>
                    <SeoBreadcrumbs />
                </ul>
                <div className="grid__unit u-size1of4 u-text-right u-strong u-pv16">
                    {this.props.showNumberOfResults ? <NumberOfResults id={'numberOfResults'} showText /> : null}
                </div>
                <hr className="grid__unit u-size1of1 u-mv0" role="presentation" />
            </section>
        );
    }
}

TopBar.contextType = WhitelabelContext;

TopBar.propTypes = {
    showFilters: PropTypes.func,
    showNumberOfResults: PropTypes.bool,
    isMobile: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
};

TopBar.defaultProps = {
    showNumberOfResults: true,
};

export default withTranslation('common')(TopBar);
